module.exports = __webpack_public_path__ + "img/frame (14).dd37babc.jpg";